
import { firestore, userUid } from '../../../firebase'
import { apiSyncReducer,apiSalveInColection } from 'scorpion-core'

export function salva(obj) {
    return apiSalveInColection(getColPerfil(), obj);
}
export function manterSincronizacao(sincronizador) {
    if (userUid())
        apiSyncReducer(getDocPerfil())(sincronizador)
}

function getDocPerfil() {
    return firestore().collection("PerfilUser").doc(userUid());
}
function getColPerfil() {
    return firestore().collection("PerfilUser")
}





// WEBPACK FOOTER //
// ./src/routes/private/PerfilUsuario/api.js